<!--
// app/components/pages/region-home/CurrentSeasonSliderMatches.vue
-->
<script setup lang="ts">
import type { Team } from "~/src/team/domain/models/Team";
import type { MatchCenterData } from "~/src/match/domain/models/Match";
import SliderMatches from "~/app/components/Shared/slider-matches/SliderMatches.vue";
import SliderWrapper from "~/app/components/Shared/SliderWrapper.vue";
import { useCompetitionStore } from "~/app/stores/competitionStore";
import { useTeams } from "~/app/composables/teams";
import { useRegions } from "~/app/composables/regions";
import { useSeasons } from "~/app/composables/season/seasons";
import ButtonEcalSync from "~/app/components/Shared/ButtonEcalSync.vue";

type Props = {
  sectionTitle?: boolean;
  withAddToCalendarInSection?: boolean;
};

withDefaults(defineProps<Props>(), {
  sectionTitle: false,
});

// const { getSeasonTurns } = useSeasons();
const { currentSeason, currentSeasonTeams } = useCompetitionStore();
const { useFetchParamsSeasonMatchCenterData } = useSeasons();
const { teamArrToObjById } = useTeams();
const { isWorldCup } = useRegions();
const { locale } = useI18n();

const teamsObj = ref<Record<number, Team>>({});

const { path, opts } = useFetchParamsSeasonMatchCenterData(currentSeason.id, locale.value);
const { data, error } = await useFetch(path, opts);

if (error.value) {
  console.error(error.value);
}

const turns: MatchCenterData[] = currentSeason ? data.value : [];

// create team Object with the team ID as key.
teamsObj.value = isWorldCup
  ? await teamArrToObjById(currentSeasonTeams, currentSeason?.id)
  : await teamArrToObjById(currentSeasonTeams);
</script>

<template>
  <div class="px-4 md:px-6 pb-8" v-if="turns && turns.length && sectionTitle">
    <p class="kql-page-section-title flex items-baseline justify-between">
      {{ $t("teams.nextMatches.title") }}
      <button-ecal-sync v-if="withAddToCalendarInSection" in-title></button-ecal-sync>
    </p>

    <hr />
  </div>
  <slider-wrapper
    v-if="turns && turns.length"
    :scroll-distance="170"
    auto-scroll-selector=".card-match.live-match, .card-match[data-last-played]"
    scrollable-selector=".matches-slider-wrapper"
  >
    <slider-matches :phase-turns="turns" :teams="teamsObj"></slider-matches>
  </slider-wrapper>
</template>

<style scoped></style>
